import { AccordionStepAction, breadcrumbsControlTypes, SetStepChangeAction } from '~/types/breadcrumbsControl';

export const setAccordionStep = (accordionStep: number): AccordionStepAction => {
  return {
    type: breadcrumbsControlTypes.SET_ACCORDION_STEP,
    accordionStep,
  };
};

export const setStepChangeTo = (stepChangeTo: number): SetStepChangeAction => {
  return {
    type: breadcrumbsControlTypes.SET_STEP_CHANGE_TO,
    stepChangeTo,
  };
};
